import { render, staticRenderFns } from "./SettingsAdvanced.vue?vue&type=template&id=0b7f98c0&"
import script from "./SettingsAdvanced.vue?vue&type=script&lang=js&"
export * from "./SettingsAdvanced.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAdvanced.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports